export function chunk<T>(items: T[], size: number = 5): T[][] {
  if (!items || items.length === 0) {
    return [];
  }

  if (size <= 0) {
    throw new Error('Chunk size must be positive');
  }

  const result: T[][] = [];

  for (let i = 0; i < items.length; i += size) {
    result.push(items.slice(i, i + size));
  }

  return result;
}

export function deduplicate(items: string[]): string[] {
  if (!items || items.length === 0) {
    return [];
  }

  const seen = new Set<string>();
  const output: string[] = [];

  for (const item of items) {
    if (!seen.has(item)) {
      seen.add(item);
      output.push(item);
    }
  }

  return output;
}
